import React, { useState, useEffect, useContext } from "react";
// import "../SalesOrder.css";
import { useSelector } from "react-redux";
import moment from "moment";
import { Select, notification, Button, Input, Modal, Table, Popconfirm } from "antd";

import "react-quill/dist/quill.snow.css";
import { HiOutlineDownload } from "react-icons/hi";
import formatIndianNumber from "../../../../../utils/formatIndianNumber";
import { openFileInNewTab } from "../../../../../utils/convertS3ToCloudFront";
import mainContext from "../context/MainContext/mainContext";
import GenerateInvoice from "./GenerateInvoice";

const List = ({ order, isCompleted = false }) => {
  const { id, setId, setArchivedInvoiceData, setFetchToggle } =
    useContext(mainContext);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [billingData, setBillingData] = useState(null);
  const [viewBillsModalOpen, setViewBillsModalOpen] = useState(false);
  const [unlockingEdit, setUnlockingEdit] = useState(false);

  const billableInventories = (order?.bdfId?.inventories || []).filter(
    (inventory) => !inventory?.lineType && inventory?.invId,
  );
  const totalAmount =
    (billableInventories.reduce(
      (acc, inventory) =>
        acc +
        (inventory?.specialRate || 0) +
        (inventory?.printingCharge || 0) +
        (inventory?.mountingCharge || 0),
      0
    ) || 0) +
    (order?.bdfId?.suffixInventories?.reduce(
      (acc, inventory) => acc + (inventory?.specialRate || 0),
      0
    ) || 0);

  const campaignStartDate = order?.bdfId?.campaignStartDate
    ? moment(order.bdfId.campaignStartDate).format("DD/MM/YYYY")
    : null;
  const campaignEndDate = order?.bdfId?.campaignEndDate
    ? moment(order.bdfId.campaignEndDate).format("DD/MM/YYYY")
    : null;

  const partyGstNumber =
    order?.partyCompany?.gstNumber ||
    order?.bdfId?.parentCompanyId?.gstNumber ||
    order?.bdfId?.brandId?.partyCompany?.gstNumber;

  const hasGstNumber = Boolean(
    partyGstNumber != null && String(partyGstNumber).trim() !== "",
  );

  const billingAmount = order?.subTotal || totalAmount;
  const isFocBilling = billingAmount === 0;
  const isB2cBilling =
    !order?.billingConfirmed && !isFocBilling && !hasGstNumber;

  const handleCloseModal = () => setIsModalOpen(false);

  const isBdfLocked = Boolean(order?.bdfId?.isLocked);
  const isSubBdf = Boolean(order?.isFromSub);
  const bdfLabel = isSubBdf ? "Sub BDF" : "BDF";
  const allowEditLabel = isSubBdf ? "Allow Sub BDF Edit" : "Allow BDF Edit";
  const bdfStamp = order?.bdfId?.stamp || "—";
  const unlockConfirmDescription = `This will unlock the ${bdfLabel} no: ${bdfStamp}`;

  const handleAllowEdit = async () => {
    if (!order?._id) {
      notification.error({ message: "Sales order not found" });
      return;
    }
    setUnlockingEdit(true);
    try {
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/unlockBdfEdit`,
        {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ salesOrderId: order._id }),
        }
      );
      const responseData = await response.json();
      if (response.ok && responseData?.success) {
        notification.success({
          message:
            responseData?.message ||
            `Edit permission granted. ${bdfLabel} can now be edited.`,
        });
        setFetchToggle((prev) => !prev);
      } else {
        notification.error({
          message: responseData?.message || "Failed to allow edit",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error occurred while allowing edit",
      });
    } finally {
      setUnlockingEdit(false);
    }
  };

  const isConsolidatedSecondaryView =
    isCompleted &&
    order?.isConsolidatedSecondary &&
    order?.primaryBillingId;
  const viewBillingId = isConsolidatedSecondaryView
    ? order.primaryBillingId
    : order?.billingId;

  // console.log("order is", order);

  const components = {
    header: {
      cell: (props) => (
        <th
          {...props}
          style={{
            ...props.style,
            backgroundColor: "#daeffe",
          }}
        />
      ),
    },
  };

  return (
    <div className="salesOrder-list fileInput first-prop" onClick={() => { }}>
      {order?.billingInfo?.length > 0 && (() => {
        const lastBilling = order.billingInfo[order.billingInfo.length - 1];
        const billingDate = lastBilling?.billingDate;
        if (!billingDate) return null;
        return (
          <div className="salesOrder-date">
            <div className="salesOrder-date-child">
              <span>{moment(billingDate).format("DD")}</span>
              <span>{moment(billingDate).format("MMM")}</span>
              <span>{moment(billingDate).format("YYYY")}</span>
            </div>
            <span className="date-vertical-border"></span>
          </div>
        );
      })()}
      <div>
        {/* <div>{client}</div> */}
        {order?.billingConfirmed && (order?.subTotal || totalAmount) === 0 ? (
          <div style={{ marginBottom: "8px" }}>
            <span
              style={{
                backgroundColor: "#f6ffed",
                border: "1px solid #b7eb8f",
                borderRadius: "4px",
                padding: "2px 8px",
                fontSize: "14px",
                color: "#52c41a",
                fontWeight: "600",
                whiteSpace: "nowrap",
                display: "inline-block",
              }}
            >
              FOC
            </span>
          </div>
        ) : isCompleted && order?.billNumbers?.length > 0 ? (
          <div style={{ marginBottom: "8px" }}>
            <div
              style={{
                fontSize: "14px",
                fontWeight: "600",
                color: "#1890ff",
                marginBottom: "4px",
              }}
            >
              Bill Number{order.billNumbers.length > 1 ? "s" : ""}:
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
              {order.billNumbers.map((billNumber, index) => (
                <span
                  key={index}
                  style={{
                    backgroundColor: "#e6f7ff",
                    border: "1px solid #91d5ff",
                    borderRadius: "4px",
                    padding: "2px 8px",
                    fontSize: "12px",
                    color: "#1890ff",
                    fontWeight: "500",
                    whiteSpace: "nowrap",
                  }}
                >
                  {billNumber}
                </span>
              ))}
            </div>
          </div>
        ) : (
          <div style={{ whiteSpace: "nowrap" }}>SO : {order?.stamp} </div>
        )}
        <div className="salesOrder-meta-info">
          Sales Person: {order?.bdfId?.salesPerson}
        </div>
        <div className="salesOrder-meta-info">
          Created By: {order?.bdfId?.createdBy?.name}
        </div>
      </div>
      <div className="salesOrder-info-dt">
        <div className="salesOrder-info-dt-child">
          <span>Amount :</span>
          <div>₹ {formatIndianNumber(order?.subTotal || totalAmount)}</div>
        </div>

        <div className="salesOrder-info-dt-child">
          <span>Inventory Count :</span>

          <div>({billableInventories.length})</div>
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "2rem",
          }}
        >
          <div>
            Party Name:{" "}
            <span style={{ color: "grey" }}>
              {order?.partyCompany?.name || order?.bdfId?.parentCompanyId?.name || order?.bdfId?.parentCompanyName || order?.bdfId?.brandId?.partyCompany?.name}
            </span>
          </div>
          <div>
            Start Date:{" "}
            <span style={{ color: "grey" }}>
              {campaignStartDate || "N/A"}
            </span>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "2rem",
          }}
        >
          <div>
            Brand Name:{" "}
            <span style={{ color: "grey" }}>
              {order?.bdfId?.brandId?.brandName?.toUpperCase()}
            </span>
          </div>
          <div>
            End Date:{" "}
            <span style={{ color: "grey" }}>
              {campaignEndDate || "N/A"}
            </span>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "2rem",
          }}
        >
          <div>
            Campaign Name:{" "}
            <span style={{ color: "grey" }}>
              {order?.bdfId?.campaignName?.toUpperCase()}
            </span>
          </div>
        </div>
      </div>
      <div className="billing-btn-wrapper" style={{ display: "flex", alignItems: "center", gap: "3rem", flexWrap: "wrap" }}>
        {order?.bdfId?.roFile && (
          <Button
            type="link"
            size="small"
            style={{ padding: 0, fontSize: "14px", fontWeight: 500 }}
            onClick={(e) => {
              e.stopPropagation();
              openFileInNewTab(order.bdfId.roFile);
            }}
          >
            View RO
          </Button>
        )}
        {order?.billingInfo?.length > 0 && (
          <span
            role="button"
            tabIndex={0}
            onClick={(e) => {
              e.stopPropagation();
              setViewBillsModalOpen(true);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                setViewBillsModalOpen(true);
              }
            }}
            style={{
              color: "#1890ff",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            Billing Info
          </span>
        )}
        {isBdfLocked && (
          <Popconfirm
            title={`${allowEditLabel}?`}
            description={unlockConfirmDescription}
            onConfirm={(e) => {
              e?.stopPropagation?.();
              handleAllowEdit();
            }}
            onCancel={(e) => e?.stopPropagation?.()}
            okText={allowEditLabel}
            cancelText="Cancel"
            placement="topRight"
          >
            <Button
              size="small"
              loading={unlockingEdit}
              onClick={(e) => e.stopPropagation()}
              style={{
                borderColor: "#faad14",
                color: "#d48806",
              }}
            >
              {allowEditLabel}
            </Button>
          </Popconfirm>
        )}
        <Button
          type="primary"
          style={
            isFocBilling && !order?.billingConfirmed
              ? {
                  backgroundColor: "#f6ffed",
                  borderColor: "#b7eb8f",
                  color: "#52c41a",
                }
              : isB2cBilling
                ? {
                    backgroundColor: "#fff7e6",
                    borderColor: "#ffd591",
                    color: "#d46b08",
                  }
                : {}
          }
          onClick={() => {
            setId(viewBillingId);
            setArchivedInvoiceData({
              gstNumber: null,
              bdfType: null,
              stamp: null,
              roNumber: null,
              parentCompanyName: null,
              remark: null,
              roFile: null,
              brandName: null,
              taxType: null,
              agencyCommission: null,
              campaignDuration: null,
              inventories: [],
              suffixInventories: [],
              IRN: null,
              AckNo: null,
              AckDate: null,
              SignedInvoice: null,
              SignedQRCode: null,
              isRejected: null,
              cancelReason: null,
              //taxes
              taxType: 0,
              IGST: 0,
              SGST: 0,
              CGST: 0,
              municipalTax: 0,
              others: 0,
              round: 0,
              HSN: "",
            });
          }}
        >
          {isConsolidatedSecondaryView
            ? "View"
            : order?.billingConfirmed
            ? "View"
            : isFocBilling
              ? "Proceed as FOC"
              : !hasGstNumber
                ? "Proceed as B2C"
                : "Create Billing"}
        </Button>
      </div>

      <GenerateInvoice
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        billingData={billingData}
      />

      <Modal
        title="Bills"
        open={viewBillsModalOpen}
        onCancel={() => setViewBillsModalOpen(false)}
        footer={null}
        width={720}
      >
        <Table
          dataSource={order?.billingInfo || []}
          rowKey={(_, index) => index}
          pagination={false}
          size="small"
          components={components}
          columns={[
            {
              title: "Billing Date",
              dataIndex: "billingDate",
              key: "billingDate",
              align: "center",
              render: (date) =>
                date ? moment(date).format("DD/MM/YYYY") : "—",
            },
            {
              title: "Bill Number",
              dataIndex: "billNumber",
              key: "billNumber",
              align: "center",
            },
            {
              title: "Type",
              dataIndex: "isConsolidated",
              key: "isConsolidated",
              align: "center",
              render: (v) =>
                v ? (
                  <span style={{ color: "#1890ff", fontWeight: 500 }}>
                    Multiple SOs
                  </span>
                ) : (
                  "Single SO"
                ),
            },
            {
              title: "Billing Duration",
              key: "billingDuration",
              align: "center",
              render: (_, record) => {
                const s = record?.startDate;
                const e = record?.endDate;
                if (!s && !e) return "—";
                const startFmt = s ? moment(s).format("DD/MM/YYYY") : "—";
                const endFmt = e ? moment(e).format("DD/MM/YYYY") : "—";
                return `${startFmt} to ${endFmt}`;
              },
            },
            {
              title: "Grand Total",
              dataIndex: "grandTotal",
              key: "grandTotal",
              align: "center",
              render: (val) =>
                val != null ? `₹ ${formatIndianNumber(val)}` : "—",
            },
          ]}
        />
      </Modal>
    </div>
  );
};
export default List;
